import { ProductVariantType } from "./ProductVariantType.js";

export const productVariantTypeToStructuredDataVariesByMap: Record<ProductVariantType, string> = {
	[ProductVariantType.Size]: "https://schema.org/size",
	[ProductVariantType.Weight]: "https://schema.org/weight",
	[ProductVariantType.None]: "",
};
